var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.357,
    height: 18,
    viewBox: "0 0 18.357 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groups_default_16px",
    transform: "translate(-368.909 -321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160571",
    "data-name": "Group 160571",
    transform: "translate(369 321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    width: 18,
    height: 18,
    fill: "rgba(255,225,225,0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 0.493,
    cy: 0.493,
    r: 0.493,
    transform: "translate(10.281 1.662)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M17.873,17.836q.324.026.648.026a7.735,7.735,0,0,0,2.585-.441,1.665,1.665,0,0,1,.009-.207A2.595,2.595,0,0,0,17.06,15.07",
    transform: "translate(-3.598 -3.267)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M6.3,15.07A2.593,2.593,0,0,0,2.25,17.213v.207a7.735,7.735,0,0,0,2.585.441q.324,0,.648-.026",
    transform: "translate(-1.591 -3.267)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3239",
    "data-name": "Group 3239",
    transform: "translate(3.892 9.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M16.372,18v.328a4.427,4.427,0,0,1-.035.579,10.4,10.4,0,0,1-10.313,0c-.017-.19-.035-.389-.035-.579V18",
    transform: "translate(-5.99 -13.132)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M17.873,17.906a5.165,5.165,0,0,0-.813-2.766",
    transform: "translate(-7.49 -12.745)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M15.688,14.764a5.189,5.189,0,0,0-8.748,0",
    transform: "translate(-6.119 -12.369)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M6.813,15.14A5.165,5.165,0,0,0,6,17.906",
    transform: "translate(-5.991 -12.745)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M14.135,5.445a2.639,2.639,0,0,1,.052.519A2.593,2.593,0,1,1,11.593,3.37",
    transform: "translate(-2.506 -1.742)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 1.945,
    cy: 1.945,
    r: 1.945,
    transform: "translate(12.978 4.878)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 1.945,
    cy: 1.945,
    r: 1.945,
    transform: "translate(1.307 4.878)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupWhiteIcon);
export default __webpack_public_path__ + "static/media/group-white-icon.964e7433e8018c5d6db92be1da5da9b9.svg";
export { ForwardRef as ReactComponent };